export const ROOT_ELEMENT_ID = 'face-recognition-slider-root';
export const DEFAULT_MATCH_THRESHOLD = 1;
export const MIN_MATCH_THRESHOLD = 0;
export const MAX_MATCH_THRESHOLD = 10;
